enum ResultsGroupingType {
  BY_QUIZZES = 'BY_QUIZZES',
  BY_USERS = 'BY_USERS',
  BY_APPOINTMENTS = 'BY_APPOINTMENTS',
}

export { ResultsGroupingType }
